import { Lock } from "lucide-react";
import { V } from "@/lib/vocab";

// The three levels the "Self-managed" master switch can hand a community (or a whole portfolio) to.
// Words come from the industry pack's seat titles — never internal role keys.
export const selfManagedLevels = () => [
  { v: "off", label: "Off", hint: "Ask Redline staff only" },
  { v: "managers", label: `${V.role("hoa_manager")}s and above`, hint: `${V.role("hoa_manager")}s and the firm's ${V.role("company_admin").toLowerCase()}s` },
  { v: "company", label: `${V.role("company_admin")}s only`, hint: `Only the ${V.lc("mgmt_co")}'s ${V.role("company_admin").toLowerCase()}s` },
  { v: "board", label: `${V.role("hoa_manager")}s + ${V.grp()}`, hint: `Plus ${V.lcs("board")} with the “Can configure” grant` },
];
export const selfManagedLabel = (v) => (selfManagedLevels().find((l) => l.v === v) || {}).label || (v === "custom" ? "Custom (dials differ)" : "Off");

// Segmented level picker shared by the community card and the portfolio card.
export function SelfManagedSwitch({ value, onChange, busy, testid = "self-managed" }) {
  const levels = selfManagedLevels();
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`${testid}-levels`}>
      {levels.map((l) => {
        const on = value === l.v;
        return (
          <button key={l.v} type="button" data-testid={`${testid}-${l.v}`} disabled={busy} onClick={() => !on && onChange(l.v)} title={l.hint}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold border transition-colors disabled:opacity-60 ${
              on ? "bg-ink text-white border-ink" : "bg-white text-ink/60 border-sand-200 hover:border-ink hover:text-ink"}`}>
            {l.v === "off" && <Lock className="inline h-3 w-3 mr-1 -mt-0.5" strokeWidth={2} />}{l.label}
          </button>
        );
      })}
      {value === "custom" && <span data-testid={`${testid}-custom`} className="self-center rounded-full bg-amber-50 text-amber-700 px-2.5 py-1 text-[11px] font-bold">Custom — dials below differ</span>}
    </div>
  );
}
